
export default {
    props:["action", "detailData", "rs","url", "autoId", "config"],
    data() {
      return {
        data: this.$extend({}, this.detailData)
      }
    },
    //computed: {
      //data: function(){
        //return this.$extend({}, this.detailData)
      //}
    //},
    methods: {
      /*checkInput(){
         if (!this.checkNull(this.data.bmbh, "nullId")) return
         if (!this.checkNull(this.data.bmmc, "nullName")) return
      },*/
      save(){
        let dt = this.data
        if (this.checkInput) {
          const rs = this.checkInput()
          if(rs == false) return
          else if (typeof rs == "object") dt = rs
        }
        if (this.action == "Add" || this.action == "Copy") {
          this.$save(this.url + "Add", dt, this.saveResult);
          
        } else if (this.action == "Edit") {
          this.$save(this.url + "Edit", dt, this.saveResult);
        }
      },
      saveResult(rs){
        if (rs.rs==1) {
          this.$parent.$data.isNeedReload=true
          if (this.action == "Add" || this.action == "Copy") {
            this.data[this.autoId]=rs.data
            this.action = "Edit"
          }
          else{
            this.$extend(this.detailData, this.data)
          }

          if (this.confirmRS("msg_save_success_back")) this.$emit("back");
        }
        else if (rs && rs.rs == -1) this.alertRS("existed")
      }
    }
  }
